import { MessageRole } from "../enums/MessageRole";
import { ChatMessageData, MessageProcessor } from "./MessageDataProcessor";

export class ChatMessage {
  public id: string;
  public errorMessage?: string;
  public startedAt: Date;
  public finishedAt?: Date;
  public data?: ChatMessageData;
  public role: MessageRole;
  public isCancelled: boolean;

  constructor(message: any) {
    this.id = message.id;
    this.errorMessage = message.errorMessage;
    this.role = message.role;
    this.startedAt = new Date(message.createdAt);
    this.isCancelled = message.isCancelled;
    if (message.finishedAt) {
      this.finishedAt = new Date(message.finishedAt);
    }
    if (message.data) {
      this.data = MessageProcessor.ParseData(this.role, message.data);
    }
  }

  public get inProgress() {
    return this.finishedAt === undefined;
  }

  public get failed() {
    return !!this.errorMessage;
  }

  public get timeInterval() {
    //plus operator converts Date to number
    return this.finishedAt ? +this.finishedAt - +this.startedAt : undefined;
  }

  public get textContent(): string | null {
    return null;
  }
}
